import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18254308"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "w-full shadow-lg border select-none border-gray-200 text-gray-800 dark:text-dark-text dark:bg-dark-800 dark:border-dark-400",
  style: {"border-radius":"1rem"}
}
const _hoisted_2 = { style: {"border-radius":"1rem"} }
const _hoisted_3 = {
  class: "panel-top flex no-select border-b px-2 bg-primary-500 border-primary-50 dark:bg-dark-400 dark:border-dark-700",
  style: {"border-top-right-radius":"1rem","border-top-left-radius":"1rem"}
}
const _hoisted_4 = { class: "flex items-center justify-center text-white dark:text-dark-text" }
const _hoisted_5 = { class: "text-2xl material-icons mr-2" }
const _hoisted_6 = { class: "text-lg font-bold" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1))
const _hoisted_8 = {
  class: "w-full",
  style: {"border-bottom-right-radius":"1rem","border-bottom-left-radius":"1rem"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.icon), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.title), 1)
        ]),
        _hoisted_7,
        _createElementVNode("div", null, [
          _createVNode(_component_IconButton, {
            icon: _ctx.buttonIcon,
            padding_bottom: 4,
            padding_left: 4,
            padding_right: 4,
            padding_top: 4,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.click()))
          }, null, 8, ["icon"])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ])
    ])
  ]))
}